import { c as _c } from "react/compiler-runtime";
import { getUploadImageKey, isVaultDataDecrypted } from '@onefootprint/core';
import type { Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { LinkButton, LoadingSpinner, Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useEntityVault from '@/entities/hooks/use-entity-vault';
import useDecryptControls from '@/entity/hooks/use-decrypt-controls';
import useOnboardingDocuments from '../../hooks/use-onboarding-documents';
type DecryptProps = {
  entity: Entity;
  onboarding: EntityOnboarding;
};

/** "Decrypt all" for the documents uploaded during an onboarding; renders nothing once they are decrypted. */
const Decrypt = t0 => {
  const $ = _c(31);
  const {
    entity,
    onboarding
  } = t0;
  const {
    t
  } = useTranslation("entity-details");
  const {
    documents
  } = useOnboardingDocuments(entity, onboarding);
  let t1;
  if ($[0] !== entity.id) {
    t1 = {
      entityId: entity.id
    };
    $[0] = entity.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: vaultData,
    update: onDecryptSuccess
  } = useEntityVault(t1);
  const decryptControls = useDecryptControls();
  if (!vaultData || !documents?.length) {
    return null;
  }
  const isAllDecrypted = documents.every(document => document.uploads.every(upload => isVaultDataDecrypted(vaultData.vault[getUploadImageKey(upload)])));
  if (isAllDecrypted) {
    return null;
  }
  let documentDIs;
  let t2;
  if ($[2] !== decryptControls || $[3] !== documents || $[4] !== vaultData) {
    documentDIs = decryptControls.getDisFromDocuments(documents, vaultData);
    t2 = decryptControls.isDecrypting(documentDIs);
    $[2] = decryptControls;
    $[3] = documents;
    $[4] = vaultData;
    $[5] = documentDIs;
    $[6] = t2;
  } else {
    documentDIs = $[5];
    t2 = $[6];
  }
  if (t2) {
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <LoadingSpinner size="compact" />;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  let t3;
  if ($[8] !== vaultData.vault) {
    t3 = Object.keys(vaultData.vault);
    $[8] = vaultData.vault;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const isVaultEmpty = t3.length === 0;
  let t4;
  if ($[10] !== documents) {
    t4 = documents.every(_temp);
    $[10] = documents;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const canDecrypt = t4;
  let t5;
  if ($[12] !== decryptControls || $[13] !== documentDIs || $[14] !== entity || $[15] !== onDecryptSuccess || $[16] !== onboarding.id) {
    t5 = async () => {
      const response = await decryptControls.decrypt({
        entity,
        fields: documentDIs,
        reason: `Examining documents for onboarding ${onboarding.id}`
      });
      onDecryptSuccess({
        vault: response,
        transforms: {}
      });
    };
    $[12] = decryptControls;
    $[13] = documentDIs;
    $[14] = entity;
    $[15] = onDecryptSuccess;
    $[16] = onboarding.id;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const handleDecryptSubmit = t5;
  let t6;
  if ($[18] !== isVaultEmpty || $[19] !== t) {
    t6 = isVaultEmpty ? t(_temp2) : t(_temp3);
    $[18] = isVaultEmpty;
    $[19] = t;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const t7 = !canDecrypt;
  let t8;
  if ($[21] !== t) {
    t8 = t(_temp4);
    $[21] = t;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== handleDecryptSubmit || $[24] !== t7 || $[25] !== t8) {
    t9 = <LinkButton disabled={t7} onClick={handleDecryptSubmit}>{t8}</LinkButton>;
    $[23] = handleDecryptSubmit;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== canDecrypt || $[28] !== t6 || $[29] !== t9) {
    t10 = <Tooltip disabled={canDecrypt} content={t6}>{t9}</Tooltip>;
    $[27] = canDecrypt;
    $[28] = t6;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
};
export default Decrypt;
function _temp(d) {
  return d.canDecrypt;
}
function _temp2($) {
  return $.decrypt.vaultEmptyNotAllowed;
}
function _temp3($_0) {
  return $_0.decrypt.notAllowed;
}
function _temp4($_1) {
  return $_1.classicOnboardings.userData.decrypt.decryptAll;
}